<h1 mat-dialog-title style = "color:#1976d2">Following Steps will be excuted</h1>
<div mat-dialog-content>
    <pre *ngIf = "!done" style = "margin: 10px; color:#1976d2" >{{steps}}</pre>
    <p *ngIf = "done" style = "margin: 10px; color:#1976d2">It's done, please go Deputy to check!</p>
</div>
<div mat-dialog-actions>
    <button *ngIf = "!done" mat-button (click)="onYesClick()" cdkFocusInitial>Yes</button>
    <button *ngIf = "done" mat-button (click)="onNoClick()" cdkFocusInitial>Close</button>
    <button *ngIf = "!done" mat-button (click)="onNoClick()">No</button>
  </div>